import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { HeaderTitle, IHeaderSummary } from 'src/app/models/generic';
import { NotificationTypeEnum } from 'src/app/models/notification';
import { DataService } from 'src/app/services/data.service';
import {
    ApproveTitle, ContractTitle, DetailsTitle, MainTitle, TransferTitle
} from 'src/app/shared/utils/base';

import { INotificationType } from '../../../models/notification';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() link!: string;

  title!: HeaderTitle;
  systemTitle = 'Módulo Financeiro';

  mainTitle = MainTitle;
  detailsTitle = DetailsTitle;
  approveTitle = ApproveTitle;
  NotificationType = NotificationTypeEnum;
  lotCreated?: string;
  lotLinked?: string;
  legacyBatchNumber?: string;
  showNotifications: boolean = false;
  route!: string;
  notifications: INotificationType[] = [];
  badgeNumber: number = 0;
  showSummary: boolean = false;
  headerSummary: IHeaderSummary[] = [];
  isModernHeader: boolean = false;

  constructor(
    private _dataService: DataService,
    private _changeDetector: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.setHeaderTitleSubscriber();
    this.setHeaderInfosSubscriber();
    this.setHeaderSummarySubscriber();
  }

  setHeaderTitleSubscriber(): void {
    this._dataService.headerTitle.subscribe({
      next: (title) => {
        if (title?.trim() && !title?.includes('undefined')) {

          this.title = title;
          this.showSummary = this.title === ContractTitle;
          this.isModernHeader = true;
          this.headerSummary = [];
          // if (this.title === this.mainTitle)
          //   this.getValoresTotais();
        }
      }
    });
  }

  setHeaderInfosSubscriber(): void {
    this._dataService.headerInfos.subscribe({
      next: (res) => {
        if (res.lotCreated?.trim() && !res.lotCreated.includes('undefined')) {
          this.lotCreated = res?.lotCreated;
          this.lotLinked = res?.lotLinked;
          this.legacyBatchNumber = res?.legacyBatchNumber;
        }
      }
    });
  }

  setHeaderSummarySubscriber(): void {
    this._dataService.headerSummary.subscribe({
      next: (headerSummary: IHeaderSummary[]) => {
        this.headerSummary = headerSummary;
      }
    });
  }

  closeNotifications(): void {
    this.showNotifications = false;
  }

  changeBadgeNumber(badgeNumber: number): void {
    this.badgeNumber = badgeNumber;
    this._changeDetector.detectChanges();
  }

}
